<template>
  <div class="foot">
    <div class="wrapper pc">
      <div class="bottom ft-row">
        <ul class="span">
          <li to="" tag="li" class="top">关于兴致力</li>
          <router-link :to="{ path: '/about' }" tag="li"
            >关于兴致力</router-link
          >
          <router-link
            :to="{ path: '/about', query: { type: 'culture' } }"
            tag="li"
            >企业文化</router-link
          >
          <router-link
            :to="{ path: '/about', query: { type: 'responsibility' } }"
            tag="li"
            >社会责任</router-link
          >
          <router-link
            :to="{ path: '/about', query: { type: 'advantage' } }"
            tag="li"
            >品牌优势</router-link
          >
          <router-link
            :to="{ path: '/about', query: { type: 'history' } }"
            tag="li"
            >发展历程</router-link
          >
          <router-link
            :to="{ path: '/about', query: { type: 'qualifications' } }"
            tag="li"
            >荣誉资质</router-link
          >
        </ul>
        <ul class="span">
          <li tag="li" class="top">兴致力服务</li>
          <router-link :to="{ path: '/service' }" tag="li"
            >兴致力服务</router-link
          >
        </ul>
        <ul class="span">
          <li tag="li" class="top">成功案例</li>
          <router-link :to="{ path: '/case' }" tag="li">成功案例</router-link>
        </ul>
        <ul class="span">
          <li tag="li" class="top">媒体资讯</li>
          <router-link :to="{ path: '/news' }" tag="li">公司动态</router-link>
        </ul>
        <ul class="span">
          <li tag="li" class="top">联系我们</li>
          <router-link :to="{ path: '/contact' }" tag="li"
            >联系我们</router-link
          >
        </ul>
        <ul class="label">
          <li to="" tag="li" class="top">联系</li>
          <router-link to="" tag="li"
            >{{ config.address }} {{ config.email }}
            {{ config.tel }}
          </router-link>
        </ul>
      </div>
	  
		  <div  style="display: flex;justify-content: center;align-items: center;border-top: 1px solid #909090;">
		  		  <a >Copyright2010-2019 3d66.com All rights reserved</a>
		  		  <a style="margin-left: 10px;">成都兴致力物业管理服务有限责任公司版权所有</a>
		  		  <a href="https://beian.miit.gov.cn/" style="margin-left: 10px;"class="ipclass" >
		  		  	<span > 蜀ICP备12019123号-4</span>
		  		  </a>
		  		  <a style="margin-left: 10px;">技术支持：浪起科技有限公司</a>
		  </div>
	  
	 
     <!-- <a href="https://beian.miit.gov.cn/"
         style="display: flex;justify-content: center;align-items: center;">
		<span >Copyright2010-2019 3d66.com All rights reserved</span>
        <span>成都兴致力物业管理服务有限责任公司版权所有</span>
		<span> 蜀ICP备12019123号</span>
        <span>技术支持：浪起科技有限公司</span>
		</a> -->
    </div>
    <div class="mobile">
      <p><i class="el-icon-arrow-up" @click="scroll"></i></p>
      <ul>
        <li>
          <div @click="active=active == 0 ? -1 : 0">
            <span>走进兴致力</span>
            <span class="plus">{{ active !== 0 ? '+' : '-' }}</span>
          </div>
          <div class="child" v-show="active == 0">
            <router-link to="" tag="div">关于兴致力</router-link>
            <router-link
              :to="{ path: '/about', query: { type: 'culture' } }"
              tag="div"
              >企业文化</router-link
            >
            <router-link
              :to="{ path: '/about', query: { type: 'responsibility' } }"
              tag="div"
              >社会责任</router-link
            >
            <router-link
              :to="{ path: '/about', query: { type: 'advantage' } }"
              tag="div"
              >品牌优势</router-link
            >
            <router-link
              :to="{ path: '/about', query: { type: 'history' } }"
              tag="div"
              >发展历程</router-link
            >
            <router-link
              :to="{ path: '/about', query: { type: 'qualifications' } }"
              tag="div"
              >荣誉资质</router-link
            >
          </div>
        </li>
        <li>
          <div @click="active = active == 1 ? -1 : 1">
            <span>兴致力服务</span>
            <span class="plus">{{ active !== 1 ? '+' : '-' }}</span>
          </div>
          <div class="child" v-show="active == 1">
            <router-link :to="{ path: '/service' }" tag="div"
              >兴致力服务</router-link
            >
          </div>
        </li>
        <li>
          <div @click="active = active == 2 ? -1 : 2">
            <span>成功案例</span>
            <span class="plus">{{ active !== 2 ? '+' : '-' }}</span>
          </div>
          <div class="child" v-show="active == 2">
            <router-link :to="{ path: '/case' }" tag="div"
              >成功案例</router-link
            >
          </div>
        </li>
        <li>
          <div @click="active = active == 3 ? -1 : 3">
            <span>媒体资讯</span>
            <span class="plus">{{ active !== 3 ? '+' : '-' }}</span>
          </div>
          <div class="child" v-show="active == 3">
            <router-link :to="{ path: '/news' }" tag="div"
              >公司动态</router-link
            >
          </div>
        </li>
        <li>
          <div @click="active = active == 4 ? -1 : 4">
            <span>联系我们</span>
            <span class="plus">{{ active !== 4 ? '+' : '-' }}</span>
          </div>
          <div class="child" v-show="active == 4">
            <router-link :to="{ path: '/contact' }" tag="div"
              >联系我们</router-link
            >
          </div>
        </li>
      </ul>
      <a href="https://beian.miit.gov.cn/"
        >Copyright2010-2019 3d66.com All rights
        reserved成都兴致力物业管理服务有限责任公司版权所有
        粤ICP备13075835号-3</a
      >
      <h3>技术支持：浪起科技有限公司</h3>
    </div>
  </div>
</template>

<script>
import { config } from '../utils/api'
export default {
  data() {
    return {
      active: -1,
      config: {},
    }
  },
  created() {
    config((r) => {
      this.config = r.data
    })
  },
  methods: {
    scroll() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="less" scoped>
	.ipclass:hover{
		color: #0000ff;
	}
.foot {
  padding-top: 80px;
  background: #1a1a1a;
  color: white;
  a {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    padding-bottom: 10px;
    text-decoration: none;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #909090;
    
  }
  .bottom::before {
    width: 1200px;
    border-bottom: 1px solid #909090;
    content: '';
    left: 0;
    position: absolute;
    height: 0;
    top: 44px;
  }
  .bottom {
    display: flex;
    margin-bottom: 40px;
    position: relative;
    li:last-child {
      margin-bottom: 0;
    }
    li {
      margin-bottom: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: #909090;
      cursor: pointer;
      width: 90px;
    }
    .top {
      padding-bottom: 20px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 24px;
      color: #ffffff;
      display: flex;
      margin-bottom: 40px;
      cursor: unset;
    }
  }

  .ft-row {
    .span {
      margin-right: 62px;

    }
    .span:nth-child(5){
      margin-right: 0;
    }
    .label {
      margin-left: 230px;
      li{
        width: 272px;
        word-break: break-all;
      }
    }
  }
}
@media (max-width: 767px) {
  .foot {
    padding-top: 0.68rem;
    padding: 0.68rem 0.34rem;
    .mobile {
      p {
        text-align: center;
        color: white;
        font-size: 0.54rem;
        border-bottom: 1px solid #707070;
        padding-bottom: 0.34rem;
      }
      ul {
        list-style: none;
      }
      li {
        border-bottom: 1px solid #707070;
        padding: 0.34rem 0;
        font-size: 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 24px;
        color: #ffffff;
        user-select: none;
        & > div:first-child {
          display: flex;
          justify-content: space-between;

          .plus {
            font-size: 0.64rem;
            font-weight: bolder;
          }
        }
        .child {
          margin-top: 0.34rem;
          div {
            padding: 0.17rem 0.68rem;
            box-sizing: border-box;
          }
        }
      }
    }
    a,
    h3 {
      text-decoration: none;
      font-size: 0.24rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 0.34rem;
      color: #909090;
      margin-bottom: 0.12rem;
      text-align: center;
    }
  }
}
</style>
